import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  private currentUserSubject = new BehaviorSubject<any | null>(null);
  public currentUser$ = this.currentUserSubject.asObservable();
  constructor(private jwtHelper: JwtHelperService) {
    this.initializeUser();
  }
  private initializeUser(): void {
    const token = this.getToken();
    const isTokenExpired = this.jwtHelper.isTokenExpired(token);
    if (token && !isTokenExpired) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      console.log(decodedToken);
      this.currentUserSubject.next({
        id: decodedToken.sub,
        username: decodedToken.username,
        roles: decodedToken.roles || [],
        permissions: decodedToken.permissions || [],
      });
    }
  }
  getToken(): string | null {
    return localStorage.getItem('UserDetails');
  }
  getCurrentUser(): any | null {
    return this.currentUserSubject.value;
  }

  hasRole(role: string): boolean {
    const user = this.getCurrentUser();
    return user?.roles.includes(role) || false;
  }

  hasAnyRole(roles: string[]): boolean {
    const user = this.getCurrentUser();
    return roles.some((role) => user?.roles.includes(role)) || false;
  }

  hasPermission(permission: string): boolean {
    const user = this.getCurrentUser();
    return user?.permissions.includes(permission) || false;
  }

  // constructor() {}
  // decodeToken(token: string): JwtPayload | null {
  //   try {
  //     const decoded = jwt_decode.default<JwtPayload>(token);
  //     return decoded;
  //   } catch (error) {
  //     console.error('Invalid JWT token', error);
  //     return null;
  //   }
  // }
  // // You can add helper functions, e.g. to check token expiry
  // isTokenExpired(token: string): boolean {
  //   const decoded = this.decodeToken(token);
  //   if (!decoded) return true;
  //   const currentTime = Math.floor(Date.now() / 1000); // seconds
  //   return decoded.exp < currentTime;
  // }
}

export interface JwtPayload {
  sub: string;
  jti: string;
  exp: number;
  organizationId: string;
  userId: string;
  fullName: string;
  userRole: string;
  platform: string;
  isEmployee: boolean;
  employeeDepartment: string;
  locationAccess: boolean;
  vibrationAccess: boolean;
  organizationAddress: string;
  organizationEmail: string;
  organizationName: string;
  profilePic: string;
  email: string;
}
